import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const TOUR_CONSENTS_BASE_QUERY_KEY = 'tourConsents';

export const tourConsentsApiQueryKeys = {
  byTourId: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, TOUR_CONSENTS_BASE_QUERY_KEY] as const,
};
